// File: src/pages/NotFoundPage.jsx
// Description: A 404 Not Found page for any undefined routes.

import React from 'react';
import { Container, Typography } from '@mui/material';

const NotFoundPage = () => {
  return (
    <Container sx={{ mt: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Oops! The page you’re looking for doesn’t exist.
      </Typography>
    </Container>
  );
};

export default NotFoundPage;
